import { combineReducers } from '@reduxjs/toolkit'
import appReducer from './app/slice'
import userReducer from './user/slice'

export const rootReducer = combineReducers({
  user: userReducer,
  app: appReducer,
})
